export enum ProviderNames {
  Amazon = "Amazon",
  Backblaze = "Backblaze"
}
